// extracted by mini-css-extract-plugin
module.exports = {"s1ng3k9s":"s1ng3k9s"};